module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "setup-view container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-8 main"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('erco-text-input', {
    staticClass: "col-12",
    attrs: {
      "label": "Objektname",
      "text": _vm.objectname,
      "keepUnfocused": true,
      "forcePointerCursor": true,
      "forceFocusOutline": _vm.isSidebarFocused('objectname'),
      "tooltip": _vm.infoTextFor('setup.objectname')
    },
    on: {
      "click": function($event) {
        _vm.openSidebarFor('objectname')
      }
    }
  })], 1), _vm._v(" "), (_vm.belongsToProductAreaOne) ? _c('div', {
    staticClass: "row"
  }, [_c('erco-text-input', {
    staticClass: "col-12",
    attrs: {
      "label": "PDB-Key",
      "text": _vm.pdbKey,
      "disabled": true,
      "keepUnfocused": true,
      "tooltip": _vm.infoTextFor('setup.pdbKey')
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('erco-text-input', {
    staticClass: "col-12",
    attrs: {
      "label": "Objektzusatz",
      "text": _vm.objectadditional,
      "placeholder": "z. B.: Version 1.0",
      "keepUnfocused": true,
      "forcePointerCursor": true,
      "forceFocusOutline": _vm.isSidebarFocused('objectadditional'),
      "tooltip": _vm.infoTextFor('setup.objectadditional')
    },
    on: {
      "click": function($event) {
        _vm.openSidebarFor('objectadditional')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('erco-text-input', {
    staticClass: "col-12",
    attrs: {
      "label": "Redakteur (Ansprechpartner Gruppe Content)",
      "text": _vm.objecteditor,
      "keepUnfocused": true,
      "forcePointerCursor": true,
      "forceFocusOutline": _vm.isSidebarFocused('objecteditor'),
      "mandatory": true,
      "tooltip": _vm.infoTextFor('setup.objecteditor')
    },
    on: {
      "click": function($event) {
        _vm.openSidebarFor('objecteditor')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('erco-text-input', {
    staticClass: "col-12",
    attrs: {
      "label": "Designer (Ansprechpartner Gruppe Media)",
      "text": _vm.objectdesigner,
      "keepUnfocused": true,
      "forcePointerCursor": true,
      "forceFocusOutline": _vm.isSidebarFocused('objectdesigner'),
      "mandatory": true,
      "tooltip": _vm.infoTextFor('setup.objectdesigner')
    },
    on: {
      "click": function($event) {
        _vm.openSidebarFor('objectdesigner')
      }
    }
  })], 1), _vm._v(" "), (_vm.isProject) ? _c('div', {
    staticClass: "row"
  }, [_c('erco-text-input', {
    staticClass: "col-12",
    attrs: {
      "label": "Land",
      "text": _vm.objectcountry,
      "keepUnfocused": true,
      "forcePointerCursor": true,
      "forceFocusOutline": _vm.isSidebarFocused('objectcountry'),
      "mandatory": true,
      "tooltip": _vm.infoTextFor('setup.objectcountry')
    },
    on: {
      "click": function($event) {
        _vm.openSidebarFor('objectcountry')
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('erco-text-input', {
    staticClass: "col-12",
    attrs: {
      "label": "Spezifikation",
      "text": _vm.specification,
      "keepUnfocused": true,
      "tooltip": _vm.infoTextFor('setup.specification'),
      "disabled": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('erco-text-input', {
    staticClass: "col-12",
    attrs: {
      "label": "Stammgattung",
      "text": _vm.basisgenus,
      "keepUnfocused": true,
      "forcePointerCursor": true,
      "forceFocusOutline": _vm.isSidebarFocused('basisgenus'),
      "tooltip": _vm.infoTextFor('setup.basisgenus')
    },
    on: {
      "click": function($event) {
        _vm.openSidebarFor('basisgenus')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('erco-text-input', {
    staticClass: "col-12",
    attrs: {
      "label": "Tags",
      "text": _vm.categories,
      "keepUnfocused": true,
      "forcePointerCursor": true,
      "forceFocusOutline": _vm.isSidebarFocused('categories'),
      "tooltip": _vm.infoTextFor('setup.categories')
    },
    on: {
      "click": function($event) {
        _vm.openSidebarFor('categories')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('erco-text-input', {
    staticClass: "col-12",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "label": "Medienformate",
      "text": _vm.mediaformats,
      "keepUnfocused": true,
      "forcePointerCursor": true,
      "forceFocusOutline": _vm.isSidebarFocused('mediaformats'),
      "tooltip": _vm.infoTextFor('setup.mediaformats')
    },
    on: {
      "click": function($event) {
        _vm.openSidebarFor('mediaformats')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('erco-text-input', {
    staticClass: "col-12",
    attrs: {
      "label": "Dreiklang",
      "text": _vm.triad,
      "keepUnfocused": true,
      "forcePointerCursor": true,
      "forceFocusOutline": _vm.isSidebarFocused('triad'),
      "tooltip": _vm.infoTextFor('setup.triad')
    },
    on: {
      "click": function($event) {
        _vm.openSidebarFor('triad')
      }
    }
  })], 1), _vm._v(" "), (_vm.isProject) ? _c('div', {
    staticClass: "row"
  }, [_c('erco-text-input', {
    staticClass: "col-12",
    attrs: {
      "label": "Verwendete Produkte",
      "text": _vm.linkedProducts,
      "keepUnfocused": true,
      "forcePointerCursor": true,
      "forceFocusOutline": _vm.isSidebarFocused('linkedProducts'),
      "tooltip": _vm.infoTextFor('setup.linkedProducts')
    },
    on: {
      "click": function($event) {
        _vm.openSidebarFor('linkedProducts')
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4",
    staticStyle: {
      "display": "none"
    }
  }, [_c('erco-checkbox-group', {
    attrs: {
      "label": "Auf der Startseite",
      "options": _vm.startpageOptions,
      "direction": "vertical",
      "tooltip": _vm.infoTextFor('setup.startpage')
    },
    on: {
      "change": _vm.handleStartpageChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('erco-checkbox-group', {
    attrs: {
      "label": "Einordnung im Light Scout",
      "options": _vm.lightscoutClassificationOptions,
      "tooltip": _vm.infoTextFor('setup.lightscoutClassification')
    },
    on: {
      "change": _vm.handleLightscoutClassificationChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('erco-checkbox-group', {
    attrs: {
      "label": "Sichtbarkeit",
      "options": _vm.visibilityOptions,
      "tooltip": _vm.infoTextFor('setup.visibility')
    },
    on: {
      "change": _vm.handleVisibilityChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('erco-checkbox-group', {
    attrs: {
      "label": "Synchsperre",
      "options": _vm.synchblockOptions,
      "tooltip": _vm.infoTextFor('setup.synchblock')
    },
    on: {
      "change": _vm.handleSynchblockChange
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-4 aside"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('label', [_vm._v("Status")]), _vm._v(" "), (_vm.statusTooltip && _vm.statusTooltip.text) ? _c('erco-tooltip', {
    attrs: {
      "variant": _vm.statusTooltip.variant,
      "title": _vm.statusTooltip.title,
      "text": _vm.statusTooltip.text
    }
  }) : _vm._e(), _vm._v(" "), _c('b-dropdown', {
    staticClass: "status-dropdown",
    attrs: {
      "text": _vm.currentSelectedStatusItem.text,
      "variant": _vm.currentSelectedStatusItem.variant
    }
  }, _vm._l((_vm.status.items), function(item, index) {
    return _c('b-dropdown-item', {
      key: index,
      attrs: {
        "active": _vm.currentSelectedStatusItem.value === item.value
      },
      on: {
        "click": function($event) {
          _vm.handleStatusClick(item)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(item.text) + "\n\t\t\t\t\t\t\t\t")])
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 last-changes-link"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openSidebarFor('lastchanges')
      }
    }
  }, [_vm._v("Letzte Änderungen")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('erco-text-input', {
    staticClass: "col-12 publish-date",
    attrs: {
      "label": "Veröffentlichung planen",
      "text": _vm.formatTimestamp(_vm.publishDateTime),
      "placeholder": "Nicht geplant",
      "keepUnfocused": true,
      "forcePointerCursor": true,
      "tooltip": _vm.infoTextFor('setup.publishdatetime'),
      "resetable": _vm.isValidPublishDateTime
    },
    on: {
      "reset": _vm.handlePublishDateTimeReset,
      "click": function($event) {
        _vm.openSidebarFor('publishdatetime')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('erco-text-input', {
    staticClass: "col-12 go-offline-date",
    attrs: {
      "label": "Offlinesetzen planen",
      "text": _vm.formatTimestamp(_vm.goOfflineDateTime),
      "placeholder": "Nicht geplant",
      "keepUnfocused": true,
      "forcePointerCursor": true,
      "tooltip": _vm.infoTextFor('setup.gooffdatetime'),
      "resetable": _vm.isValidGoOfflineDateTime
    },
    on: {
      "reset": _vm.handleGoOfflineDateTimeReset,
      "click": function($event) {
        _vm.openSidebarFor('gooffdatetime')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('label', [_vm._v("Prozess")]), _vm._v(" "), (_vm.processTooltip && _vm.processTooltip.text) ? _c('erco-tooltip', {
    attrs: {
      "variant": _vm.processTooltip.variant,
      "title": _vm.processTooltip.title,
      "text": _vm.processTooltip.text
    }
  }) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "process-block"
  }, [_c('div', {
    staticClass: "row padding-bottom"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "approval-indicator",
    class: {
      '-error': !_vm.mandatoryFieldsStatus,
      '-completed': _vm.mandatoryFieldsStatus
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "helptext fullwidth"
  }, [_vm._v(_vm._s(_vm.mandatoryFieldsText))])])]), _vm._v(" "), _vm._l((_vm.pkStatus), function(item) {
    return _c('div', {
      key: item[0],
      staticClass: "row padding-bottom"
    }, [_c('div', {
      staticClass: "col-12"
    }, [_c('div', {
      staticClass: "approval-indicator",
      class: {
        '-progress': [1, 3, 4, 6, 8, 9, 10, 13, 14].indexOf(parseInt(_vm.getPkStatus(item[0]), 10)) !== -1,
          '-completed': [2, 5, 7, 11, 15, 16].indexOf(parseInt(_vm.getPkStatus(item[0]), 10)) !== -1
      }
    }), _vm._v(" "), _c('b-dropdown', {
      staticClass: "fullwidth",
      attrs: {
        "text": _vm.getPkLabel(_vm.getPkStatus(item[0])) ? _vm.getPkLabel(_vm.getPkStatus(item[0])) : _vm.approval[item[0]],
        "size": "md"
      }
    }, _vm._l((item[1]), function(value, index) {
      return _c('div', {
        key: index
      }, [_c('b-dropdown-item', {
        on: {
          "click": function($event) {
            _vm.handlePkStatusClick(value)
          }
        }
      }, [_vm._v(_vm._s(value.S_Status_Aktion))])], 1)
    }))], 1)])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "export-block"
  }, [_c('a', {
    staticClass: "id-text-rtf-export",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.triggerIDTextRTFExport
    }
  }, [_vm._v("\n\t\t\t\t\tID-Text für Übersetzung herunterladen\n\t\t\t\t")])]), _vm._v(" "), (_vm.change) ? _c('div', {
    staticClass: "row bottombar"
  }, [_c('div', {
    staticClass: "col col-12"
  }, [(_vm.change.info) ? _c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "col col-12"
  }, [_c('b-alert', {
    staticClass: "info_",
    attrs: {
      "variant": _vm.change.info.variant,
      "show": ""
    }
  }, [(_vm.change.info.title) ? _c('span', {
    staticClass: "_title"
  }, [_vm._v(_vm._s(_vm.change.info.title) + ":")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "_text"
  }, [_vm._v(_vm._s(_vm.change.info.text))])])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row controls"
  }, [_c('div', {
    staticClass: "col col-auto"
  }, [_c('b-button', {
    staticClass: "apply",
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.handleAsideChangeWithPreCheck
    }
  }, [_vm._v("Bestätigen")]), _vm._v(" "), _c('b-button', {
    staticClass: "cancel",
    on: {
      "click": _vm.handleAsideCancel
    }
  }, [_vm._v("Abbrechen")])], 1)])])]) : _vm._e()])]), _vm._v(" "), _c('b-modal', {
    ref: "actionConfirmation",
    staticClass: "action-confirmation-modal",
    attrs: {
      "id": "action-confirmation",
      "title": _vm.actionConfirmationModalState.title,
      "closeTitle": "Abbrechen"
    },
    on: {
      "ok": _vm.handleAsideChange
    }
  }, [_c('p', {
    staticClass: "_infotext"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.actionConfirmationModalState.text)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "selected-obj-list-container"
  }, [_c('b-list-group', {
    staticClass: "selected-obj-list"
  }, [_c('b-list-group-item', {
    staticClass: "_entry_"
  }, [_c('span', {
    staticClass: "_title font-weight-bold"
  }, [_vm._v(_vm._s(_vm.objectname))]), _vm._v(" "), _c('span', {
    staticClass: "_id float-left text-muted"
  }, [_vm._v(_vm._s(_vm.objectid))]), _vm._v(" "), _c('span', {
    staticClass: "_badge"
  }, [_c('erco-status-badge', {
    attrs: {
      "status": _vm.objectstatus
    }
  })], 1)])], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1445771c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/organisms/ErcoObjectView/Setup.vue
// module id = 596
// module chunks = 0